var map = {
	"./blocked.svg": "fc64",
	"./blocked_p.svg": "59b5",
	"./blocked_unstarted.svg": "82bf",
	"./blocked_unstarted_p.svg": "b78e",
	"./canceled.svg": "b124",
	"./canceled_p.svg": "31b3",
	"./completed.svg": "2bae",
	"./completed_p.svg": "f4b3",
	"./pushed.svg": "baa4",
	"./pushed_p.svg": "e3c7",
	"./started.svg": "ac9f",
	"./started_p.svg": "b28d",
	"./unstarted.svg": "abca",
	"./unstarted_p.svg": "84cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";